/* eslint-disable */
import React, { useEffect, useState } from "react";
import classNames from "classnames";

import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import SweetAlert from "react-bootstrap-sweetalert";

import { Helmet } from "react-helmet-async";
import { makeStyles } from "@material-ui/core/styles";
import InshaHeader from "views/InshaBanglesPage/Section/InshaHeader";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";

import Parallax from "components/Parallax/Parallax.js";
import InshaFooter from "./InshaFooter";
import InshaHeaderLink from "./InshaHeaderLink";

import aboutUsStyle from "assets/jss/material-kit-pro-react/views/aboutUsStyle.js";
import styles from "assets/jss/material-kit-pro-react/views/componentsSections/sectionCards.js";
import style from "assets/jss/material-kit-pro-react/views/sweetAlretStyle";

const useStyles = makeStyles(aboutUsStyle);
const useStyle = makeStyles(styles);
const useAlertStyles = makeStyles(style);

const countryPhoneLengths = {
  in: { min: 10, max: 10 },
  us: { min: 10, max: 10 },
  ae: { min: 9, max: 9 },
  pk: { min: 10, max: 10 },
  bd: { min: 10, max: 10 },
  gb: { min: 10, max: 10 },
  ca: { min: 10, max: 10 },
  au: { min: 9, max: 9 },
  sa: { min: 9, max: 9 },
  ng: { min: 10, max: 10 },
  ke: { min: 9, max: 9 },
  za: { min: 9, max: 10 },
  de: { min: 8, max: 11 },
  fr: { min: 9, max: 10 },
  it: { min: 9, max: 10 },
  es: { min: 9, max: 9 },
  cn: { min: 11, max: 11 },
};

export default function SearchWhatsApp() {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  }, []);

  const classes = useStyles();
  const classe = useStyle();
  const alertClasses = useAlertStyles();

  const [mobile, setMobile] = useState("");
  const [mobileErr, setMobileErr] = useState("");
  const [countryCode, setCountryCode] = useState("in");
  const [countryName, setCountryName] = useState("India");
  const [dialCode, setDialCode] = useState("91");

  // alert state and type ('success' or 'error')
  const [alert, setAlert] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");
  const [alertType, setAlertType] = useState("success");

  const handlePhoneChange = (value, countryData) => {
    setMobile(value);
    setMobileErr("");
    if (countryData) {
      setCountryCode(countryData.countryCode.toLowerCase());
      setDialCode(countryData.dialCode);
      setCountryName(countryData.name);
    }
  };

  const SubmitSearchClient = () => {
    if (!mobile) {
      setMobileErr("Please enter a mobile number.");
      return;
    }

    const numericMobile = mobile.replace(/\D/g, "");

    let nationalNumber = numericMobile;
    if (numericMobile.startsWith(dialCode)) {
      nationalNumber = numericMobile.slice(dialCode.length);
    }

    const { min = 5, max = 15 } = countryPhoneLengths[countryCode] || {};

    if (nationalNumber.length < min || nationalNumber.length > max) {
      setAlertMsg(
        `Please enter a valid mobile number (${min}-${max} digits) for ${countryName}.`
      );
      setAlertType("error");
      setAlert(true);
      return;
    }

    const message = `Hi there! 👋
I'm Indian Bangles Manufacture & Wholesale.
Could you please provide more details? Thanks!

More info: https://indianbangles.in
Please get back to me. Thanks!`;

    const encodedMessage = encodeURIComponent(message);

    const whatsAppLink = `https://api.whatsapp.com/send?phone=${numericMobile}&text=${encodedMessage}&app_absent=0`;

    window.open(whatsAppLink, "_blank");

    setAlertMsg(`Searching WhatsApp for: +${numericMobile} (${countryName})`);
    setAlertType("success");
    setAlert(true);
  };

  const hideAlert = () => {
    setAlert(false);
    if (alertType === "success") {
      window.location.reload();
    }
  };

  return (
    <div>
      <Helmet>
        <title>Search Client WhatsApp</title>
        <meta
          name="description"
          content="Indian Bangles Search Client WhatsApp Our policy lasts 30 days. If 30 days have gone by since your purchase, unfortunately we can't offer you a refund or exchange "
        />
        <meta name="keywords" content="Indian Bangles Search client WhatsApp" />
      </Helmet>
      <InshaHeader
         brand="INSHA BANGLES PRIVATE LIMITED"
        links={<InshaHeaderLink dropdownHoverColor="dark" />}
        fixed
        color="transparent"
        changeColorOnScroll={{
          height: 300,
          color: "dark",
        }}
      />
      <Parallax image={require("assets/img/bg2.png").default} filter="dark" small>
        <div className={classes.container}>
          <GridContainer justify="center">
            <GridItem
              md={10}
              sm={10}
              className={classNames(
                classes.mlAuto,
                classes.mrAuto,
                classes.textCenter
              )}
            >
              <h1
                style={{
                  color: "#fff",
                  fontFamily: "Tahoma",
                  fontWeight: "bold",
                }}
              >
                Search WhatsApp
              </h1>
              <h4 style={{ color: "#fff" }}>Client</h4>
            </GridItem>
          </GridContainer>
        </div>
      </Parallax>
      <div className={classNames(classes.main, classes.mainRaised)}>
        <div className={classe.container}>
          {/* Centered form wrapper with margin top & bottom, and left & right margin */}
          <GridContainer justify="center" alignItems="center">
            <GridItem
              xs={12}
              sm={12}
              md={6}
              style={{
                margin: "5% auto",
                display: "block",
                paddingLeft: "15px",
                paddingRight: "15px",
                boxSizing: "border-box",
              }}
            >
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  SubmitSearchClient();
                }}
                style={{ width: "100%", maxWidth: 360, margin: "0 auto" }}
              >
                <PhoneInput
                  country={countryCode}
                  value={mobile}
                  onChange={handlePhoneChange}
                  enableAreaCodes={true}
                  disableCountryGuess={true}
                  countryCodeEditable={false}
                  inputStyle={{ width: "100%" }}
                  containerStyle={{ width: "100%" }}
                  required
                />
                <br />
                <div className={classes.center}>
                  <span style={{ color: "red" }}>{mobileErr}</span>
                </div>
                <br />
                <div className={classes.center} style={{ marginLeft: "20%"}}>
                  <Button
                    color="rose"
                    type="submit"
                    className={classes.updateProfileButton}
                    style={{ minWidth: 200 }}
                  >
                    Search Client WhatsApp
                  </Button>
                </div>
              </form>
            </GridItem>
          </GridContainer>
        </div>
        {alert && (
          <SweetAlert
            title={alertType === "error" ? "Error" : "Success"}
            success={alertType === "success"}
            error={alertType === "error"}
            onConfirm={hideAlert}
            confirmBtnCssClass={
              alertType === "success"
                ? alertClasses.button + " " + alertClasses.success
                : alertClasses.button + " " + alertClasses.danger
            }
          >
            {alertMsg}
          </SweetAlert>
        )}
      </div>
      <br />
      <br />
      <InshaFooter />
    </div>
  );
}
